'use strict';/* global define */define('modules/electron/services/electron/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
     factory.$inject = ["$window"];
function factory($window){// jshint validthis:true
// jshint latedef:false
return{isClient:isClient};// ---
/**
     * Is the current user agent the electron client
     *
     * @return {Boolean} is electron client
     *
     * @tested
     */function isClient(){return (/loopline/i.test($window.navigator.userAgent));}}module.exports=factory;});
